import icons from 'currency-icons';
import { isNull } from 'lodash';
import React from "react";

export const searchArray = (arr, searchWord) => {
  const lowerCaseSearchWord = searchWord?.toLowerCase();
  return arr?.filter((item) => {
    return Object.values(item).some((value) => typeof value === 'string' && value.toLowerCase().includes(lowerCaseSearchWord));
  });
};
export const searchDashboard = (arr, searchWord, keysToSearch = []) => {
  const lowerCaseSearchWord = searchWord?.toLowerCase();
  if (!lowerCaseSearchWord) return arr;

  return arr?.filter((item) => {
    return keysToSearch.some((key) => {
      const value = item[key];
      return typeof value === 'string' && value.toLowerCase().includes(lowerCaseSearchWord);
    });
  });
};


export const currencyFormatter = (value) => {
  const selectedProfile = JSON.parse(sessionStorage.getItem('selectedProfileId'));
  if (isNull(value) || isNaN(value)) {
    return `${icons[selectedProfile?.currencyCode ? selectedProfile?.currencyCode : 'INR']?.symbol}` + 0;
  }
  if (value < 10) {
    return (
      `${icons[selectedProfile ? selectedProfile?.currencyCode : 'INR']?.symbol}` +
      Number(value)
        .toFixed(2)
        .toLocaleString(`en-${selectedProfile ? selectedProfile.countryCode : 'IN'}`)
    );
  } else {
    return (
      `${icons[selectedProfile ? selectedProfile?.currencyCode : 'INR']?.symbol}` +
      Math.round(parseFloat(value)).toLocaleString(`en-${selectedProfile ? selectedProfile.countryCode : 'IN'}`)
    );
  }
};

const omitKeys = (obj, keysToIgnore) => Object.fromEntries(Object.entries(obj).filter(([key]) => !keysToIgnore.includes(key)));

export const isDifferent = (a, b, ignoreKeys = []) => {
  if (a.length !== b.length) return true;

  for (let i = 0; i < a.length; i++) {
    const objA = omitKeys(a[i], ignoreKeys);
    const objB = omitKeys(b[i], ignoreKeys);

    const sortedA = Object.keys(objA)
      .sort()
      .reduce((acc, key) => {
        acc[key] = objA[key];
        return acc;
      }, {});

    const sortedB = Object.keys(objB)
      .sort()
      .reduce((acc, key) => {
        acc[key] = objB[key];
        return acc;
      }, {});

    if (JSON.stringify(sortedA) !== JSON.stringify(sortedB)) {
      return true;
    }
  }

  return false;
};

export const isDifferentFlight = (a = [], b = [], ignoreKeys = []) => {
  // Early length check only for completely new flights without flightId
  if (a.length !== b.length) return true;

  const normalize = obj => {
    const clean = omitKeys(obj, ignoreKeys);
    return Object.keys(clean)
      .sort()
      .reduce((acc, key) => {
        acc[key] = clean[key];
        return acc;
      }, {});
  };

  // Map for quick lookup by flightId (or unique signature for new ones)
  const mapB = new Map(
    b.map(f => [f.flightId || JSON.stringify(normalize(f)), normalize(f)])
  );

  for (const flightA of a) {
    const key = flightA.flightId || JSON.stringify(normalize(flightA));
    const normalizedA = normalize(flightA);
    const normalizedB = mapB.get(key);

    if (!normalizedB || JSON.stringify(normalizedA) !== JSON.stringify(normalizedB)) {
      return true; // Different or missing in B
    }
  }

  return false; // All matched
};


export const isDifferentOnCommonKeys = (obj1, obj2) => {
  if(!obj1 && !obj2) return false;
  const commonKeys = Object.keys(obj1).filter(key => key in obj2);

  return commonKeys.some(key => {
    const val1 = obj1?.[key];
    const val2 = obj2?.[key];

    if (key === "targetKpi" && typeof val1 === "number" && typeof val2 === "number") {
      return val1?.toFixed(2) !== val2?.toFixed(2);
    }

    return val1 !== val2;
  });
};

export const isArrayDifferent = (arr1, arr2) => {
  console.log(arr1, arr2 , 'isArrayDifferent');
  
  if (arr1.length !== arr2.length) return true;

  for (const obj1 of arr1) {
    const match = arr2.find((obj2) => obj2.recurrenceTimePeriod === obj1.recurrenceTimePeriod);
    if (!match) return true; // recurrenceTimePeriod not found in arr2
    if (obj1.amount !== match.amount) return true; // amount mismatch
  }

  return false;
};

export const isObjectDifferent = (obj1, obj2, ignoreKeys = []) => {
  if (!obj1 || !obj2) return true;

  const cleanObj1 = omitKeys(obj1, ignoreKeys);
  const cleanObj2 = omitKeys(obj2, ignoreKeys);

  const sortedKeys1 = Object.keys(cleanObj1).sort();
  const sortedKeys2 = Object.keys(cleanObj2).sort();

  if (sortedKeys1.length !== sortedKeys2.length) return true;

  for (let key of sortedKeys1) {
    if (cleanObj1[key] !== cleanObj2[key]) {
      return true;
    }
  }

  return false;
};


export const createErrorMessage = (errors, type) => {
  if(typeof errors === "string") {
    return [{
      errorMessage: errors,
      errorCode:
        type === 'campaign'
          ? 'Error! Campaign creation'
          : type === 'product'
          ? 'Error! Conversion tracking product'
          : type === 'off-amazon'
          ? 'Error! Off-Amazon conversion tracking'
          : type === 'adGroup'
          ? 'Error! AdGroup failed'
          : type === 'removedInventory'
          ? 'Error! Remove exist inventory sources'
          : type === 'targets'
          ? 'Error! Add Targeting'
          : type === 'deleteTargets'
          ? 'Error! Remove exist target'
          : type === 'adCreatives'
          ? 'Error! Creative associations'
          : type === 'removeCreatives'
          ? 'Error! Remove exist creative'
          : type === 'createCreative'
          ? 'Error! Create creative'
          : type === 'adExperiences'
          ? 'Error! adExperiences'
          : '',
      type: type
    }]
  } else if (errors && errors?.length > 0) {
    return errors?.map((item) => ({
      ...item,
      errorCode:
        type === 'campaign'
          ? 'Error! Campaign creation'
          : type === 'product'
          ? 'Error! Conversion tracking product'
          : type === 'off-amazon'
          ? 'Error! Off-Amazon conversion tracking'
          : type === 'adGroup'
          ? 'Error! AdGroup failed'
          : type === 'removedInventory'
          ? 'Error! Remove exist inventory sources'
          : type === 'targets'
          ? 'Error! Add Targeting'
          : type === 'deleteTargets'
          ? 'Error! Remove exist target'
          : type === 'adCreatives'
          ? 'Error! Creative associations'
          : type === 'removeCreatives'
          ? 'Error! Remove exist creative'
          : type === 'createCreative'
          ? 'Error! Create creative'
          : type === 'adExperiences'
          ? 'Error! adExperiences'
          : '',
      type: type
    }));
  } else {
    return [];
  }
};

export const createErrorMessageList = (errors) => {
  const adGroupErrors = []
  if (Array.isArray(errors)) {
    errors.forEach((error) => {
      if (typeof error?.errorMessage === "string") {
        adGroupErrors.push({
          message: error.errorMessage
        });
      }

      if (Array.isArray(error?.subErrors)) {
        error.subErrors.forEach((subError) => {
          if (subError?.errorMessage) {
            adGroupErrors.push({
              message: subError.errorMessage
            });
          }
        });
      }

      if (Array.isArray(error?.errors)) {
        error.errors.forEach((subError) => {
          if (subError?.errorMessage) {
            adGroupErrors.push({
              message: subError.errorMessage,
              errorCode: subError.errorCode
            });
          }
        });
      }
    });
  } else if (typeof errors === "string") {
    adGroupErrors.push({ message: errors });
  }
  return adGroupErrors;
}

export const resizeImageToBase64 = (file, width, height) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        const base64 = canvas.toDataURL('image/jpeg'); // or 'image/png'
        resolve(base64);
      };
      img.onerror = (err) => reject('Image load error: ' + err);
      img.src = event.target.result;
    };
    reader.onerror = (err) => reject('File read error: ' + err);
    reader.readAsDataURL(file);
  });
};
const selectedProfile = JSON.parse(sessionStorage.getItem('selectedProfileId'));

export const ACTION_OPTIONS = {
  minimumCPM: {
    key: 'minimumCPM',
    title: 'Change Minimum CPM',
    description: 'Choose to increase, decrease, or set the Minimum CPM using a specific amount or percentage.',
    inputLabel: '₹ Value',
    dropdownLabel: 'Minimum CPM',
    dropdownOptions: [
      { label: `Increase Minimum CPM by (%)`, value: 'increase_percent' },
      { label: `Increase Minimum CPM by (${icons[selectedProfile ? selectedProfile?.currencyCode : 'INR']?.symbol})`, value: 'increase_value' },
      { label: `Change Minimum CPM to (${icons[selectedProfile ? selectedProfile?.currencyCode : 'INR']?.symbol})`, value: 'set_value' },
      { label: `Decrease Minimum CPM by (%)`, value: 'decrease_percent' },
      { label: `Decrease Minimum CPM by (${icons[selectedProfile ? selectedProfile?.currencyCode : 'INR']?.symbol})`, value: 'decrease_value' }
    ]
  },
  maximumCPM: {
    key: 'maximumCPM',
    title: 'Change Maximum CPM',
    description: 'Choose to increase, decrease, or set the Maximum CPM using a specific amount or percentage.',
    inputLabel: '₹ Value',
    dropdownLabel: 'Maximum CPM',
    dropdownOptions: [
      { label: `Increase Maximum CPM by (%)`, value: 'increase_percent' },
      { label: `Increase Maximum CPM by (${icons[selectedProfile ? selectedProfile?.currencyCode : 'INR']?.symbol})`, value: 'increase_value' },
      { label: `Change Maximum CPM to (${icons[selectedProfile ? selectedProfile?.currencyCode : 'INR']?.symbol})`, value: 'set_value' },
      { label: `Decrease Maximum CPM by (%)`, value: 'decrease_percent' },
      { label: `Decrease Maximum CPM by (${icons[selectedProfile ? selectedProfile?.currencyCode : 'INR']?.symbol})`, value: 'decrease_value' }
    ]
  },
  Budget: {
    key: 'Budget',
    title: 'Change Budget',
    description: 'Choose to increase, decrease, or set the budget using a specific amount or percentage.',
    inputLabel: '₹ Budget',
    dropdownLabel: 'Budget',
    dropdownOptions: [
      { label: `Increase budget by (%)`, value: 'increase_percent' },
      { label: `Increase budget by (${icons[selectedProfile ? selectedProfile?.currencyCode : 'INR']?.symbol})`, value: 'increase_value' },
      { label: `Change budget to (${icons[selectedProfile ? selectedProfile?.currencyCode : 'INR']?.symbol})`, value: 'set_value' },
      { label: `Decrease budget by (%)`, value: 'decrease_percent' },
      { label: `Decrease budget by (${icons[selectedProfile ? selectedProfile?.currencyCode : 'INR']?.symbol})`, value: 'decrease_value' },
      
    ]
  },
  activate: {
    key: 'activate',
    title: 'Activate',
    description: 'The selected {type} will get activated.',
  },
  deActivate: {
    key: 'deActivate',
    title: 'Deactivate',
    description: 'The selected {type} will get Deactivated.',
  },
  startDate: {
    key: 'startDate',
    title: 'Start Date',
    dropdownLabel: 'date',
    description: 'Choose to set the start date and apply to all selected {type}.',
  },
  endDate: {
    key: 'endDate',
    title: 'End Date',
    dropdownLabel: 'date',
    description: 'Choose to set the end date and apply to all selected {type}.',
  },
  pacing: {
    key: 'pacing',
    title: 'Pacing',
    description: 'Choose to set the pacing and apply to all selected {type}.',
  },
  frequency: {
    key: 'frequency',
    title: 'Frequency',
    description: 'Choose to set the frequency and apply to all selected {type}.',
  },
  viewabilityRate: {
    key: 'viewabilityRate',
    title: 'Viewability Rate',
    description: 'Choose to set the viewability rate and apply to all selected {type}.',
  },
  audienceMatch: {
    key: 'audienceMatch',
    title: 'Audience Match',
    description: 'Choose to set the audience match and apply to all selected {type}.',
  },
  budgetCap: {
    key: 'budgetCap',
    title: 'Budget Cap',
    description: 'Choose to set the budget cap and apply to all selected {type}.',
  },
  location: {
    key: 'location',
    title: 'Location Preference',
    description: 'Choose to set the location preference and apply to all selected {type}.',
  }
};

export const countryLanguageMap = {
  FR: [
    { id: 'fr', name: 'French' },
    { id: 'ge', name: 'German' },
    { id: 'en', name: 'English' },
    { id: 'sp', name: 'Spanish' },
    { id: 'it', name: 'Italian' }
  ],
  UK: [
    { id: 'fr', name: 'French' },
    { id: 'ge', name: 'German' },
    { id: 'en', name: 'English' },
    { id: 'sp', name: 'Spanish' },
    { id: 'it', name: 'Italian' }
  ],
  DE: [
    { id: 'fr', name: 'French' },
    { id: 'ge', name: 'German' },
    { id: 'en', name: 'English' },
    { id: 'sp', name: 'Spanish' },
    { id: 'it', name: 'Italian' },
    { id: 'cz', name: 'Czech' },
    { id: 'pl', name: 'Polish' },
    { id: 'tr', name: 'Turkish' }
  ],
  ES: [
    { id: 'fr', name: 'French' },
    { id: 'ge', name: 'German' },
    { id: 'en', name: 'English' },
    { id: 'sp', name: 'Spanish' },
    { id: 'it', name: 'Italian' },
    { id: 'pt', name: 'Portuguese' }
  ],
  IT: [
    { id: 'fr', name: 'French' },
    { id: 'ge', name: 'German' },
    { id: 'en', name: 'English' },
    { id: 'sp', name: 'Spanish' },
    { id: 'it', name: 'Italian' }
  ],
  IN: [
    { id: 'en', name: 'English' },
    { id: 'bn', name: 'Bangla' },
    { id: 'gu', name: 'Gujarati' },
    { id: 'hi', name: 'Hindi' },
    { id: 'kn', name: 'Kannada' },
    { id: 'ml', name: 'Malayalam' },
    { id: 'mr', name: 'Marathi' },
    { id: 'pa', name: 'Punjabi' },
    { id: 'ta', name: 'Tamil' },
    { id: 'te', name: 'Telugu' }
  ],
  SA: [
    { id: 'ar', name: 'Arabic' },
    { id: 'en', name: 'English' }
  ],
  AE: [
    { id: 'ar', name: 'Arabic' },
    { id: 'en', name: 'English' }
  ],
  NL: [
    { id: 'en', name: 'English' },
    { id: 'fr', name: 'French' },
    { id: 'nl', name: 'Dutch' }
  ],
  SE: [
    { id: 'sv', name: 'Swedish' },
    { id: 'da', name: 'Danish' },
    { id: 'en', name: 'English' },
    { id: 'fi', name: 'Finnish' },
    { id: 'no', name: 'Norwegian' }
  ],
  TR: [{ id: 'tr', name: 'Turkish' }],
  US: [
    { id: 'sp', name: 'Spanish' },
    { id: 'en', name: 'English' }
  ],
  CA: [
    { id: 'en', name: 'English' },
    { id: 'fr', name: 'French' }
  ],
  MX: [
    { id: 'sp', name: 'Spanish' },
    { id: 'en', name: 'English' }
  ],
  BR: [
    { id: 'pt', name: 'Portuguese' },
    { id: 'en', name: 'English' }
  ]
};

export const  haveFlightsChanged = (flightsPayload=[], flights=[])=> {
  const flightsMap = new Map(flights?.map(f => [f?.flightId, f]));

  // 1. Check if budgetAmount changed or new flight added
  for (const payloadFlight of flightsPayload) {
    const existing = flightsMap.get(payloadFlight.flightId);

    if (!existing) {
      // new flight added
      return true;
    }

    if (payloadFlight.budgetAmount !== existing.budgetAmount) {
      // budget changed
      return true;
    }
  }

  // 2. Check if a flight exists in flights but not in payload (deleted flight)
  for (const f of flights) {
    if (!flightsPayload.find(p => p.flightId === f.flightId)) {
      return true;
    }
  }

  // If we reach here, only dates may differ
  return false;
}

export default function CreativeExactPreview({ htmlContent }) {
  // Extract JSON from htmlContent
  const match = htmlContent?.match(/AdaptiveRenderer\.default\((\{.*\})\)/s);
  const data = match ? JSON.parse(match[1]) : null;

  if (!data) return <p>Preview data not available</p>;

  const { creativeInformation } = data;
  console.log(creativeInformation, 'creativeInformation');

  // Get all image variants dynamically (square, tall, wide)
  const imageVariants = Object.entries(creativeInformation?.customImages || {});

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', padding: '16px 0' }}>
      {imageVariants.map(([key, image]) => (
        <div
        className='inter py-1'
          key={key}
          style={{
            border: '1px solid #ddd',
            borderRadius: '12px',
            padding: '16px',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            maxWidth: 600,
            margin: '0 auto',
            background: '#fff'
          }}
        >
          {/* Image */}
          <img
            src={image.url}
            alt={`${key} creative`}
            width={image?.realCrop?.width}
            height={image?.realCrop?.height}
            style={{
              // width: '100%',
              borderRadius: '8px',
              objectFit: 'cover'
            }}
          />

          {/* Text */}
          <div style={{ textAlign: 'left' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                marginBottom: '12px'
              }}
            >
              {/* Brand Logo */}
              {creativeInformation?.brandLogo?.url && 
              <img
                src={creativeInformation?.brandLogo?.url}
                alt="brand logo"
                width={creativeInformation?.brandLogo?.width}
                height={creativeInformation?.brandLogo?.height}
                style={{
                  maxHeight: '40px',
                  maxWidth: '40px',
                  borderRadius: '50%', // optional, for rounded logos
                  objectFit: 'contain'
                }}
              />
              }
              

              {/* Brand Name */}
              {creativeInformation?.brand && 
               <h3 style={{ margin: 0 }}>{creativeInformation?.brand}</h3>
              }
            </div>
            {creativeInformation?.headline && 
            <h3 style={{ margin: '4px 0' }}>{creativeInformation?.headline}</h3>}
            {creativeInformation?.bodyText && 
            <p style={{ margin: '4px 0', color: '#444' }}>{creativeInformation?.bodyText}</p> }
            {creativeInformation?.disclaimer && <p style={{ fontSize: '12px', color: '#777' }}>{creativeInformation.disclaimer}</p>}
          </div>

          {/* CTA Button */}
          {creativeInformation?.callToAction && (
            <a
              href={creativeInformation?.clickThroughInfo?.adLink}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-block',
                alignSelf: 'flex-start',
                background: '#000',
                color: '#fff',
                padding: '8px 16px',
                borderRadius: '8px',
                fontWeight: 'bold',
                textDecoration: 'none'
              }}
            >
              {creativeInformation.callToAction.replace(/_/g, ' ')}
            </a>
          )}
        </div>
      ))}
    </div>
  );
}


export const  formatPascalCaseString = (str)=> {
  if (!str) return '';

  // If string is ALL CAPS (no lowercase letters)
  const isAllCaps = /^[A-Z0-9_]+$/.test(str);

  // Replace underscores with spaces
  let formatted = str.replace(/_/g, ' ');

  if (isAllCaps) {
    // Convert to Pascal Case (capitalize first letter only)
    formatted = formatted
      .toLowerCase()
      .replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());
  }

  return formatted;
}

export const FORMAT_PAYLOAD_FOR_METRICS_LIST = {
  1: {
    report: "OrderName",
    aggregate: "MetricList",
    summary: "OrderName"
  },
  2: {
    report: "geoGraphy",
    aggregate: "MetricGeoGraphyList",
    summary: "geoGraphy"
  },
  3: {
    report: "Segment",
    aggregate: "MetricSegmentList",
    summary: "Segment"
  },
  4: {
    report: "Browser",
    aggregate: "MetricBrowserList",
    summary: "Browser"
  },
  5: {
    report: "Products",
    aggregate: "MetricProductsList",
    summary: "Products"
  }
};

export const FORMAT_PAYLOAD_FOR_METRICS_WIDGET = {
  1: {
    report: "OrderName",
    aggregate: "MetricListWidget",
    summary: "OrderName"
  },
  2: {
    report: "geoGraphy",
    aggregate: "MetricListgeoGraphyWidget",
    summary: "geoGraphy"
  },
  3: {
    report: "Segment",
    aggregate: "MetricListSegmentWidget",
    summary: "Segment"
  },
  4: {
    report: "Browser",
    aggregate: "MetricListBrowserWidget",
    summary: "Browser"
  },
  5: {
    report: "Products",
    aggregate: "MetricListProductWidget",
    summary: "Products"
  }
};

export const sortWeeks = (
  list = [],
  {
    weekKey = 'Week',
    order = 'desc', // 'desc' | 'asc'
  } = {}
) => {
  if (!Array.isArray(list)) return [];

  const multiplier = order === 'asc' ? 1 : -1;

  return [...list].sort((a, b) => {
    const matchA = a?.[weekKey]?.match(/Week\s+(\d+).*?,\s*(\d{4})/);
    const matchB = b?.[weekKey]?.match(/Week\s+(\d+).*?,\s*(\d{4})/);

    if (!matchA || !matchB) return 0;

    const [, weekA, yearA] = matchA;
    const [, weekB, yearB] = matchB;

    // 1️⃣ Year comparison
    if (+yearA !== +yearB) {
      return (+yearA - +yearB) * multiplier;
    }

    // 2️⃣ Week comparison
    return (+weekA - +weekB) * multiplier;
  });
};

export const isValidEnterListASIN = (value) =>
  /^[A-Z0-9]{10}$/.test(String(value ?? '').trim().toUpperCase());
